import React, { useState, useRef, useEffect } from "react";
import "./YearBar.scss";

// Barra de año ancha con desplegable — mismo patrón/colores reales que
// action-plans-page__year-bar (client/src/pages/admin/ActionPlans/ActionPlans.scss),
// acá como componente compartido para no duplicarlo en cada dashboard que lo
// necesite (Inicio, Checklist, y los que sigan).
//
// `options` acepta números (años) o { value, text } — si es un número se usa
// tal cual como label.
export function YearBar({ year, options, onChange, className = "" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const normalized = options.map((o) =>
    typeof o === "object" ? o : { value: o, text: String(o) }
  );

  return (
    <div className={`year-bar${className ? ` ${className}` : ""}`} ref={ref}>
      <button type="button" className="year-bar__toggle" onClick={() => setOpen((v) => !v)}>
        <span className="year-bar__label">{year}</span>
        <svg
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round" width="20" height="20"
          className={`year-bar__arrow${open ? " year-bar__arrow--open" : ""}`}
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v6m0 0-2.5-2.5M12 14l2.5-2.5" />
        </svg>
      </button>

      {open && (
        <div className="year-bar__menu">
          {normalized.map((o) => (
            <button
              type="button"
              key={o.value}
              className={`year-bar__menu-item${o.value === year ? " year-bar__menu-item--active" : ""}`}
              onClick={() => { onChange(o.value); setOpen(false); }}
            >
              {o.text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
